<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Permohonan Tanda Tangan Batch"
        class="card-wrapper"
        >
        <form>
          <v-alert v-if="batchFinishedCount > 0" border="left" type="info">
            <div>{{ batchFinishedMessage }}</div>
            <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
            <!-- <v-row align="center" v-for="i in confirmRejectList" :key="i"> -->
            <v-row align="center">
              <v-col class="grow">
                Klik 'x' untuk membersihkan notifikasi
              </v-col>
              <v-col class="shrink">
                <v-btn fab x-small color="white" @click="removeNotification()"><v-icon size="20" color="info">mdi-window-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-alert>

          <!-- <v-alert v-if="denyRejectCount > 0" border="left" dismissible type="warning">
            <div>
              {{ denyRejectMessage }}
            </div>
          </v-alert> -->

          <esign-filter-panel>
          <div style="height: 80px" class="form-input row">
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Username Pengaju</p>
              <v-text-field
                  v-model="searchForm.usernamePengaju"
                  placeholder="Username"
                  dense
                  outlined
                  clearable
              />
            </div>
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Nama Batch</p>
              <v-text-field
                outlined
                placeholder="Nama Batch"
                clearable
                dense
                  v-model="searchForm.batchName"
              /> 
            </div>
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Nama Organisasi</p>
              <v-autocomplete
                  :items="organisasis"
                  :item-text="item => item.nama"
                  :item-value="item => item.id"
                  no-data-text="Tidak ada data"
                  placeholder="Pilih Nama Organisasi"
                  clearable
                  dense
                  outlined
                  v-model="searchForm.organisasi"
                  @keydown.enter.prevent
              ></v-autocomplete>
            </div>
          </div>
          <div style="height: 80px" class="form-input row">
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
              <v-autocomplete
                :items="filteredJenisDokumen"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                no-data-text="Tidak ada data"
                placeholder="Pilih Jenis Dokumen"
                clearable
                dense
                outlined
                v-model="searchForm.jenisDokumen"
                @keydown.enter.prevent
              ></v-autocomplete>
            </div>
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
              <v-text-field
                type="date"
                outlined
                clearable
                dense
                  v-model="searchForm.tanggalPengajuan"
              /> 
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchDokumen()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          </esign-filter-panel>
          <br>
        </form>
        <v-card>
            <div class="col-8">
              <v-text-field
              v-model="search"
              class="esign-table-search"
              prepend-inner-icon="mdi-magnify"
              label="Cari di tabel"
              outlined
              dense
              clearable
              single-line
              hide-details
            ></v-text-field>
            </div>
            <!-- <div class="col-4" v-if="isSelectAll">
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="selectAllTable()"
              >Klik untuk pilih keseluruhan tabel</v-btn>
            </div> -->
            <!-- <v-data-table
                :headers="headers"
                :search="search"
                :items="items"
                @toggle-select-all="selectAll"
                no-data-text="Tidak ada data"
                no-results-text="Data tidak ditemukan"
                class="elevation-1"
                :loading="isLoading"
                loading-text="Memuat data..."
                v-model="selected"
                item-key="id_ttd_batch"
                :item-class="itemDenyReject"
                selectable-key="selectable"
                show-select
                :options.sync="options"
                hide-default-footer  
            >
            <!--   <template v-slot:footer="{ props, on }">
            <!--     <esign-table-footer
            <!--     :pagination="props.pagination"
            <!--     :options="props.options"
            <!--     @update:options="on['update:options']"
            <!--     />
            <!--   </template> -->
            <v-data-table
                :headers="headers"
                :search="search"
                :items="items" 
                no-data-text="Tidak ada data"
                no-results-text="Data tidak ditemukan"
                class="elevation-1"
                :loading="isLoading"
                loading-text="Memuat data..."  
                :options.sync="options"
                show-select
                v-model="selected"
                item-key="id_ttd_batch"
                @toggle-select-all="selectAllToggle"
                hide-default-footer
            >
              <template v-slot:footer="{ props, on }">
                <esign-table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update:options="on['update:options']"
                >
                  <v-btn small color="primary" :disabled="selected.length === 0" @click="showTtd">
                    <v-icon left small>mdi-draw</v-icon>
                    Tanda tangan{{ selected.length > 0 ? ` (${selected.length})` : '' }}
                  </v-btn>
                  <v-btn small outlined color="primary" @click="refreshTable">
                    <v-icon left small>mdi-refresh</v-icon>
                    Refresh
                  </v-btn>
                </esign-table-footer>
              </template>
              <template v-slot:item.status_dokumen="{ item }">
                <esign-status-tag :value="item.status_dokumen" />
              </template>
                <template
                    v-for="header in headers.filter((header) =>
                      header.hasOwnProperty('formatter')
                    )"
                    v-slot:[`item.${header.value}`]="{ header, value }"
                  >
                    {{ header.formatter(value) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="d-flex justify-center align-center">
                    <v-btn style="margin:auto" small color="primary" dark @click="detailBatch(item)">Detail</v-btn>
                  </div>
                </template>
                <template v-slot:item.keterangan_urutan="{ item }">
                  <esign-status-tag :tone="item.flag_urutan ? 'success' : 'warning'" :value="item.keterangan_urutan" />
                </template>
              <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <v-simple-checkbox
                    :value="isSelected"
                    :readonly="!item.selectable"
                    :disabled="!item.selectable"
                    @input="select($event)"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
            <!-- <div class="row" v-if="selected.length > 0">
              <div class="col-2">
                  <h4 dense class="label" style="padding-top:0.5em">Input Passphrase</h4>
              </div>
              <div class="col-3">
                  <v-text-field
                      type="password"
                      v-model="passphrase"
                      dense
                      clearable
                      outlined
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                  />
              </div>
              <div class="col-2">
                <v-btn style="min-width:120px" color="primary" @click="sign()">{{ computedText }}</v-btn>
              </div>
            </div> -->
        </v-card>
        <esign-confirm-dialog
          v-model="ttd_dialog"
          tone="primary"
          icon="mdi-draw"
          title="Tanda tangani batch?"
          confirm-text="Tanda Tangan"
          :loading="loadingTtd"
          :cancel-disabled="batalTtd"
          @confirm="ttd()"
        >
          Masukkan passphrase sertifikat elektronik Anda untuk menandatangani dokumen yang dipilih.
          <template v-slot:field>
            <p class="label mb-1">Passphrase sertifikat elektronik</p>
            <v-text-field
              dense
              clearable
              outlined
              hide-details
              autocomplete="off"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              @keydown.enter="!loadingTtd && ttd()"
              placeholder="Passphrase"
              aria-label="Passphrase"
              v-model="batchForm.passphrase"
            />
          </template>
        </esign-confirm-dialog>
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        </material-card>
        <v-overlay
          :opacity="0.5"
          :value="overlay"
        >
          <v-progress-circular indeterminate size="64">
            Loading...
          </v-progress-circular>
        </v-overlay>
    </v-container>
  </template>

<script>
import { apiServer } from "../../setup-axios";
var moment = require('moment');
export default {
  data: () => ({
    search: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: true,
    menu: false,
    dialog: false,
    showPassword: false,
    organisasis: [],
    jenisDokumens: [],
    statusDokumens: [],
    items: [],
    selected: [],
    isSelectAll: false,
    headers: [
        // { text: "Nomor Pengajuan", value: "nomor_pengajuan" },
        { text: "Nama Batch", value: "batch_name"},
        { text: "Jumlah Dokumen", value: "jumlah_dokumen"},
        { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null) },
        { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
        { text: "Nama Organisasi", value: "nama_organisasi"},
        // { text: "id arsip", value: "id_arsip"},
        // { text: "id ttd", value: "id_ttd_batch"},
        // { text: "id penttd", value: "id_penandatangan"},
        { text: "Username Pengaju", value: "username_pengaju"},
        { text: "Alur", value: "alur_persetujuan"},
        { text: "Sumber", value: "source"},
        { text: "Status", value: "status_dokumen"},
        { text: "Keterangan", value: "keterangan_urutan"},
        // { text: '', value: 'data-table-select' },
        { text: "Aksi", align:"center", value: "action", sortable: false}
    ],
    searchForm: {
      usernamePengaju: "",
      jenisDokumen: -1,
      tanggalPengajuan: null,
      batchName: "",
      userId: -1,
      organisasi: -1
    },
    overlay: false,
    countCheck: 0,
    isRahasia: false,
    countRahasia: 0,
    signButtonText: "",
    signForm: [],
    batchForm: {
      passphrase:"",
      selectedList: []
    },
    passphrase:"",
    options: {},
    totalData: 0,
    tgl:null,
    // bulk_list: [],
    ttd_bulk: false,
    peran: "",
    user: null,
    confirmRejectMessage:"",
    denyRejectMessage:"",
    confirmRejectCount:0,
    denyRejectCount:0,
    confirmRejectList:[],
    idTtdDenyRejectList:[],
    ttd_dialog: false,
    batalTtd: false,
    batalDialog: false,
    loadingTtd: false,
    finishedList: [],
    batchFinishedMessage:"",
    batchFinishedCount:0,
  }),
  computed: {
    filteredJenisDokumen(){
        return this.jenisDokumens.filter(item => item.status)
    },
    computedText(){
        let jumlah_sign = this.selected.length
        let text = jumlah_sign > 1 ? "Tanda tangani " + jumlah_sign + " dokumen"  : "Tanda tangan"
        return text
    }
  },
  props: {
      batchName: "",
  },
  created() {
    this.searchForm.batchName = this.batchName
    this.peran =localStorage.getItem("currentPeran")
    this.user= JSON.parse(localStorage.getItem("user")) 
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    this.getDropdownJenisDokumen()
    this.getDropdownOrganisasi()
    if (this.peran!='A03') {
        this.$router.push('/403')
      } 
    this.searchForm.userId = this.user.id 
    // paging/sorting is done by the table itself, so the list is loaded once
    this.getData()
    console.log("searchForm", JSON.stringify(this.searchForm))
    this.getNotificationAlert()
  },
  methods: {
    selectAllToggle(props) {
      let availableItems = props.items.filter(item => item.selectable)

      if (this.selected.length !== availableItems.length) {
        this.selected = [...availableItems]
      } else {
        this.selected = []
      }
    },
    getData() {  
        this.isLoading = true;
        let tanggal_pengajuan = null
        if (this.searchForm.tanggalPengajuan) {
          tanggal_pengajuan = moment(this.searchForm.tanggalPengajuan).format('DD-MM-YYYY')
        } 
        apiServer
          .get("/batch/sign_list", {
            params: {
              batch_name: this.searchForm.batchName, 
              username_pengaju: this.searchForm.usernamePengaju,
              id_jenis_dokumen: this.searchForm.jenisDokumen,
              tanggal_pengajuan: tanggal_pengajuan,
              penandatangan_login: this.searchForm.userId,
              id_organisasi: this.searchForm.organisasi
            }
          })
          .then(response => {
            this.isLoading = false;
            this.items = response.data.data;
            this.modifyColumn()
            this.totalData = this.items.length
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          }); 
    },
    showTtd() {
      if (this.selected.length === 0) {
        this.showSnackbar("error", "Pilih minimal satu batch terlebih dahulu")
        return
      }

      this.batchForm.selectedList = this.selected
      this.ttd_dialog = true
    },
    refreshTable() {
      this.selected = []
      this.getData()
    },
    async ttd() {
      this.batalTtd = true;
      this.loadingTtd = true;
      const payload = this.batchForm.selectedList.map(item => ({
        id_batch: item.id_batch,
        id_ttd_batch: item.id_ttd_batch,
        id_user_login: this.user.id,
        passphrase: this.batchForm.passphrase
      }))
      try {
        await apiServer.put("/batch/sign", payload);

        this.showSnackbar("success", 'Penandatanganan sedang diproses harap tunggu');
        this.getData()
      } catch (error) {
        this.showSnackbar("error", error.response.data.message);
      } finally {
        this.batalTtd = false;
        this.loadingTtd = false;
        this.ttd_dialog = false;
      }
    },
    selectAll() {
      this.isSelectAll = true
    },
    selectAllTable() {
      // alert("all")
      this.selected = []
      for(let item of this.items){
        if (item.selectable) {
          this.selected.push(item)
        }
      }
    },
    itemDenyReject(item) {
      if (this.idTtdDenyRejectList.includes(item.id_ttd_batch)) {
        return 'deny-reject'
      }
    },
    getNotificationAlert() {
      apiServer
        .get("/batch/finished_list", {
          params: {
            id_penandatangan_login: this.user.id
          }
        })
        .then(response => {
          this.finishedList = response.data.data
          this.batchFinishedCount = this.finishedList.length
          if (this.batchFinishedCount > 0) {
            const batchNames = this.finishedList.map(function(i) {
                return i.batch_name
            })
            this.batchFinishedMessage = "Terdapat " + this.batchFinishedCount + " permohonan batch berhasil ditandatangan dengan nama batch: " + batchNames.join(", ")
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    removeNotification() {
      var removedList = [] 
      for(let item of this.finishedList){
        removedList.push({
          current_id_ttd_batch: item.id_ttd_batch
        })
      } 
      apiServer
        .put("/batch/remove_notification", removedList)
        .then(response => {
          console.log(response)
          if (response.data.status == 'ok') {
              this.$router.go("/batch-sign");
            }
        })
        .catch(error => {
          console.log("There was an error:", error); // Logs out the error 
        });
    },
    isSingleJenis() {
        let single_jenis = false;
        if (this.totalData == 1) { 
          single_jenis = true }
        else {
          const idJenisDokumens = this.items.map(function(i) {
            return i.id_jenis_dokumen
          })
          const uniqueElements = [...new Set(idJenisDokumens)]
          console.log("uniq: " + JSON.stringify(uniqueElements))
          if (uniqueElements.length == 1) {
              single_jenis = true 
          } else {
              single_jenis = false 
          } 
        }
    },
    modifyColumn() {
      this.items.forEach((item, _) => {
        if(item.alur_persetujuan !== 'Berjenjang') {
          if (item.flag_urutan) {
            if (item.flag_on_process) {
              item.selectable = false
              item.keterangan_urutan = "Dalam Proses"
            } else {
              item.selectable = true
              item.keterangan_urutan = "Sesuai Urutan"
            }
          }
        }

        if(item.alur_persetujuan === 'Berjenjang') {
          if (item.flag_urutan) {
            if (item.flag_on_process) {
              item.selectable = false
              item.keterangan_urutan = "Dalam Proses"
            } else {
              item.selectable = true
              item.keterangan_urutan = "Sesuai Urutan"
            }
          } else {
            item.selectable = false
            item.keterangan_urutan = "Menunggu urutan penandatangan"
          }
        } 
      })
    },
    getDropdownJenisDokumen() {
      apiServer
        .get("/arsip/dropdown_jenis_dok")
        .then(response => {
          this.jenisDokumens = response.data.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getDropdownOrganisasi() {
      apiServer
          .get("/organisasi/all")
          .then(response => {
            this.organisasis = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
          });
    },
    tick() {
        var jumlah_sign = this.selected.length
        this.countRahasia = 0
        for(let item of this.selected){
          if(item.id_kerahasiaan == 1) {
            this.countRahasia ++
          }
        }
        this.signButtonText = jumlah_sign > 1 ? "Tanda tangani " + jumlah_sign + " dokumen"  : "Tanda tangan" 
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    searchDokumen(){
      console.log("search"+JSON.stringify(this.searchForm))
      // this.search = ""
      if (!this.searchForm.jenisDokumen) {
        this.searchForm.jenisDokumen = -1
      } 
    //   if (!this.searchForm.statusDokumen) {
    //     this.searchForm.statusDokumen = -1
    //   }
      this.options.page = 1
      this.getData()
    },
    async sign() {
      this.overlay = true
      this.validSignForm()
      
      if (this.countRahasia > 0 && this.passphrase == "") {
          this.showSnackbar("error", "Dokumen bersifat rahasia dan sangat rahasia membutuhkan passphrase")
          this.overlay = false
      } else {
        apiServer
          .put("/arsip/sign_bulk_batch", this.signForm)
          .then(response => {
            console.log("sign bulk " + response.data.data)
            // if (response.data.data == null) {
              this.$router.go('/sign');
              // localStorage.setItem('success', this.signForm.length + " Dokumen berhasil ditandatangani")
              this.showSnackbar("success", this.signForm.length + " Dokumen berhasil ditandatangani")
              this.overlay = false
            // }
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
            this.overlay = false
            this.showSnackbar("error", error.response.data.message);
          });
      }
    },
    validSignForm() {
      this.signForm = []
      this.selected.forEach((item, index) => {
          this.signForm.push({
            id_arsip_dokumen: item.id_arsip,
            nomor_pengajuan: item.nomor_pengajuan,
            alur_persetujuan: item.alur_persetujuan,
            nama_jenis_dokumen: item.nama_jenis_dokumen,
            id_jenis_dokumen_organisasi: item.id_jenis_dokumen_organisasi,
            id_ttd_arsip_dokumen: item.id_ttd_arsip_dokumen,
            username_pengaju: item.username_pengaju,
            id_user_login: this.user.id,
            username_login: this.user.username,
            passphrase: this.passphrase,
            nik: this.user.pengguna.nik
          })
      })
    },
    detailItem(item) {
      this.$router.push('/dokumen/detail/'+item.id_arsip);
    },
    detailBatch(item) {
      this.$router.push('/batch-sign/detail/'+item.id_batch);
    },
    detailNotification(item) {
      // console.log(item.status_dokumen == "Selesai")
      if (item.status_dokumen == "Selesai") {
        apiServer
          .put("/arsip/update_time/" + item.id_ttd_batch)
          .then(response => {
            if (response.data.code == 200) {
              this.$router.push('/dokumen/detail/'+item.id_arsip);
              window.location.reload();
            }
          })
          .catch(error => {
            console.log("There was an error:", error.response);
          });
      } else {
        this.$router.push('/dokumen/detail/'+item.id_arsip);
      }
    }
  }
};
</script>

<style>
    .deny-reject {
      background-color: rgb(250, 198, 170)
    }
</style>